import { useSelector } from 'react-redux';
import { getModule, getModuleName } from '../redux/selectors/modules';
import useGruser from './useGruser';
import { camelCase } from 'lodash';
export const useModule = (moduleId)=>{
    const gruser = useGruser();
    return useSelector((state)=>getModule(state, gruser, moduleId));
};
export const useModuleName = (moduleId)=>{
    const gruser = useGruser();
    return camelCase(useSelector((state)=>getModuleName(state, gruser, moduleId)) || '');
};
export default useModule;
